// FilterDialog.js
import {
    defineComponent,
    ref,
    computed,
    watch,
    inject,
    nextTick,
    onMounted,
    onUnmounted
} from "/Scripts/vue.esm-browser.js";
import BudgetFilter from "/Component/Shop/filter/BudgetFilter.js";
import DatepickerFilter from "/Component/Shop/filter/DatepickerFilterM.js";
import { debounce } from "/Scripts/tools.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
const html = String.raw;
export default defineComponent({
    name: "FilterDialog",
    components: {
        BudgetFilter,
        DatepickerFilter,
    },
    props: {
        filters: {
            type: Object,
            required: true,
        },
        groupData: {
            type: Array,
            required: true,
        },
        filteredDataByGroup: {
            type: Array,
            required: true,
        },
        navModel: {
            type: Array,
            default: () => [],
        },
        quickData: {
            type: Array,
        },
        isSearch: {
            type: Boolean,
            default: false
        },
    },
    emits: ["update:filters", "reset-filters", "toggle-filter"],
    inject: ["groupShowType"],
    setup(props, { emit }) {
        const priceRangeKey = ref(Date.now());
        const filteredDataByGroup = computed(() => props.filteredDataByGroup);
        const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
        const groupShowType = inject("groupShowType");
        const sorts = inject("sorts");
        const compareGroups = inject("compareGroups");
        const isVisible = ref(false);
        const isActive = ref(false);
        const modalContentRef = ref(null);
        const tempQuick = ref(-1); //快速前往暫存
        const tempSort = ref("date_asc");//排序暫存
        const tempGroupType = ref(""); //顯示方式暫存
        const tempPriceRange = ref([0, 0]); //價格暫存
        const tempDateRange = ref([0, 0]); //日期暫存
        //const tempDateStart = ref(""); //日期起始暫存
        //const tempDateEnd = ref(""); //日期結束暫存
        const tempWeekDay = ref(new Set()) //星期幾暫存
        const tempDayRange = ref([]); //旅遊天數暫存
        const tempFeatureTags = ref(new Set()); //特色標籤暫存
        const tempAirline = ref(new Set()); //航空公司暫存

        const selectedIndex = ref(-1);
        const selectedLocationIndex = ref(-1);
        const selectedThemeIndex = ref(-1);

        const syncTempStateFromFilters = () => {
            tempPriceRange.value = [...(props.filters.priceRange || [0, 0])];
            tempDateRange.value = [...(props.filters.dateRange || ["", ""])];
            tempWeekDay.value = new Set(props.filters.selectedWeekdays || []);
            tempFeatureTags.value = new Set(props.filters.featureTags || []);
            tempAirline.value = new Set(props.filters.selectedAirlines || []);
            tempDayRange.value = (props.filters.dayRanges || []).map((item) => ({ ...item }));
            tempGroupType.value = groupShowType.value;

            const activeSortEntry = Object.entries(sorts.value).find(([, value]) => value.active);
            if (activeSortEntry) {
                tempSort.value = `${activeSortEntry[0]}_${activeSortEntry[1].sort}`;
            }
        };



        //預算
        const priceRangeMin = computed(() =>
            props.groupData
                .flatMap((group) =>
                    group.groups.flatMap((item) => item.sitePrice)
                )
                .reduce((min, price) => Math.min(min, price), Infinity)
        );
        const priceRangeMax = computed(() =>
            props.groupData
                .flatMap((group) =>
                    group.groups.flatMap((item) => item.sitePrice)
                )
                .reduce((max, price) => Math.max(max, price), -Infinity)
        );
        //日期
        const dateRangeStart = computed(
            () =>
                props.groupData
                    .flatMap((group) =>
                        group.groups.flatMap((item) => item.leaveDate)
                    )
                    .sort()[0]
        );
        const dateRangeEnd = computed(
            () =>
                props.groupData
                    .flatMap((group) =>
                        group.groups.flatMap((item) => item.leaveDate)
                    )
                    .sort()[
                props.groupData.flatMap((group) =>
                    group.groups.flatMap((item) => item.leaveDate)
                ).length - 1
                ]
        );

        const airlines = computed(() => {
            // Get all unique airline codes first
            const allAirlineCodes = props.groupData
                .flatMap((group) => group.groups)
                .flatMap((item) => item.airlineCodes)
                .filter((item) => item);
            const uniqueAirlines = [...new Set(allAirlineCodes)];

            // Count groups containing each airline code
            const airlineGroupCount = {};

            uniqueAirlines.forEach((airline) => {
                // For each airline, count how many group.groups entries contain it
                const count = props.groupData.reduce((total, group) => {
                    // Count matching groups in this parent group
                    const matchingGroups = group.groups.filter((item) =>
                        item.airlineCodes.includes(airline)
                    ).length;

                    return total + (matchingGroups > 0 ? 1 : 0);
                }, 0);

                airlineGroupCount[airline] = count;
            });

            // Sort airline codes by their group count (descending)
            return uniqueAirlines.sort(
                (a, b) => airlineGroupCount[b] - airlineGroupCount[a]
            );
        });
        const tags = computed(() => {
            // Get all unique airline codes first
            const allTags = props.groupData.flatMap(
                (group) => group.hashTagList
            );
            const uniqueTags = [...new Set(allTags)];
            return uniqueTags;
        });
        const availableWeekdays = computed(() => {
            const days = [
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
            ];
            const weekdays = [
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
                "星期日",
            ];
            return weekdays.filter((day) => {
                const dayIndex = days.indexOf(day);
                return props.groupData.some((group) =>
                    group.groups.some((item) => {
                        const itemDay = new Date(item.leaveDate).getDay();
                        return itemDay === dayIndex;
                    })
                );
            });
        });
        const availableDayRanges = computed(() => {
            return props.filters.dayRanges
                .map((range, index) => ({ ...range, originalIndex: index }))
                .filter((range) => {
                    return props.groupData.some((group) =>
                        group.groups.some((item) => {
                            const days = item.groupDay;

                            if (range.rangeStart === 0) {
                                return days <= range.rangeEnd;
                            } else if (range.rangeEnd === 0) {
                                return days >= range.rangeStart;
                            } else {
                                return days >= range.rangeStart && days <= range.rangeEnd;
                            }
                        })
                    );
                });
        });
        // Handle price range update (simplified, you might want to use a slider library)
        const updatePriceRange = ({ min, max }) => {
            tempPriceRange.value = [min, max];
        };

        // Handle date range update
        const updateDateRange = (start, end) => {
            tempDateRange.value = [start, end];
        };
        const updateCheckbox = (key, value, checked) => {
            if (key === "selectedWeekdays") {
                checked
                    ? tempWeekDay.value.add(value)
                    : tempWeekDay.value.delete(value);
            } else if (key === "dayRanges") {
                const updatedDayRanges = [...tempDayRange.value];
                updatedDayRanges[value] = {
                    ...updatedDayRanges[value],
                    active: checked,
                };
                tempDayRange.value = updatedDayRanges;
            } else if (key === "featureTags") {
                checked
                    ? tempFeatureTags.value.add(value)
                    : tempFeatureTags.value.delete(value);
            } else if (key === "selectedAirlines") {
                checked
                    ? tempAirline.value.add(value)
                    : tempAirline.value.delete(value);
            }
            //emit("update:filters", newFilters);
        };
        const reset = () => {
            tempQuick.value = -1;
            tempGroupType.value = "horizontal";
            tempSort.value = "date_asc";
            tempPriceRange.value = [props.filters.defaultPriceRange[0] || 0, props.filters.defaultPriceRange[1] || 0];
            tempDateRange.value = [props.filters.defaultDateRange[0] || 0, props.filters.defaultDateRange[1] || 0];
            tempWeekDay.value = new Set([]);
            tempDayRange.value = [
                { rangeStart: 1, rangeEnd: 2, active: false },
                { rangeStart: 3, rangeEnd: 5, active: false },
                { rangeStart: 5, rangeEnd: 7, active: false },
                { rangeStart: 7, rangeEnd: 10, active: false },
                { rangeStart: 10, rangeEnd: 0, active: false },
            ];
            tempFeatureTags.value = new Set([]);
            tempAirline.value = new Set([]);
        };
        const submit = async () => {
            const newFilters = { ...props.filters };

            //送出後把temp資料都放回去filter

            //顯示
            groupShowType.value = tempGroupType.value;
            //排序
            const [key, direction] = tempSort.value.split("_");
            Object.entries(sorts.value).forEach(([k, v]) => {
                v.active = (k === key);
                if (k === key) {
                    v.sort = direction;
                }
            });

            //預算
            newFilters.priceRange = tempPriceRange.value;
            //日期
            newFilters.dateRange = tempDateRange.value;
            //出發星期
            newFilters.selectedWeekdays = new Set(tempWeekDay.value || []);
            //旅遊天數
            newFilters.dayRanges = tempDayRange.value || [];
            //特色標籤
            newFilters.featureTags = new Set(tempFeatureTags.value || []);
            //航空公司
            newFilters.selectedAirlines = new Set(tempAirline.value || []);
            //快速前往
            if (tempQuick.value > -1) {
                setIndex(tempQuick.value, true);
            }
            else {
                //如果沒選且畫面在第一個上方就前往第一個
                const firstAreaAttr = isSingleArea.value ? "data-location-name" : "data-area-name";
                const firstElement = document.querySelector(`[${firstAreaAttr}]`);

                if (firstElement) {
                    const topNavHeight = getTopNavHeight(); // 若有固定導航需扣掉高度
                    const elementTop = firstElement.getBoundingClientRect().top;
                    const scrollThreshold = 20; // 容許誤差

                    // 如果畫面已在第一個區塊的上方（或幾乎在上面）
                    if (elementTop - topNavHeight > scrollThreshold) {
                        setIndex(0, true);
                    }
                }
            }


            //最後更新filter
            emit("update:filters", newFilters);

            mobileFilterPopup.value = false;
        }

        // 是否為單一區域，前台顯示效果不同
        const isSingleArea = computed(
            () => filteredDataByGroup.value.length === 1
        );

        // 快取常用 DOM 元素的函數
        const getElement = (selector) => document.querySelector(selector);

        const getTopNavHeight = () => {
            const topNav = getElement(".destination_topnav");
            if (!topNav) return 0;

            // 如果目前 display: none，就暫時顯示來量高度
            const isHidden = getComputedStyle(topNav).display === "none";

            if (isHidden) {
                // 儲存原始樣式
                const originalDisplay = topNav.style.display;
                const originalVisibility = topNav.style.visibility;
                const originalPosition = topNav.style.position;

                // 套用暫時樣式（讓它顯示但不佔空間且不可見）
                topNav.style.display = "block";
                topNav.style.visibility = "hidden";
                topNav.style.position = "absolute";

                const height = topNav.offsetHeight;

                // 還原原始樣式
                topNav.style.display = originalDisplay;
                topNav.style.visibility = originalVisibility;
                topNav.style.position = originalPosition;

                return height;
            } else {
                return topNav.offsetHeight;
            }
        };

        // 計算區域資料的簡化版本
        const areas = computed(() => props.navModel || []);

        const selectedArea = computed(
            () => areas.value[selectedIndex.value] || {}
        );
        const selectedAreaLocations = computed(() =>
            isSingleArea.value ? areas.value : selectedArea.value?.locations || []
        );

        // 通用滾動函數
        const scrollToElement = (element) => {
            if (!element) return;
            const topNavHeight = getTopNavHeight();
            const headerEl = document.querySelector('.header_m');
            let mobileHeaderheight = 0;
            if (headerEl) {
                mobileHeaderheight = headerEl.offsetHeight;
            }
            const targetTop =
                element.getBoundingClientRect().top +
                window.scrollY -
                topNavHeight - mobileHeaderheight;
            window.scrollTo({
                top: targetTop,
                behavior: "smooth",
            });
        };

        // 尋找元素的通用函數
        const findElementByAttribute = (
            selector,
            attributeName,
            targetValue
        ) => {
            const elements = document.querySelectorAll(selector);
            return Array.from(elements).find(
                (element) =>
                    getTextWithoutSign(element.getAttribute(attributeName)) ===
                    getTextWithoutSign(targetValue)
            );
        };

        // 使用統一的選擇器對象進行元素查找
        const selectors = {
            area: {
                attr: () =>
                    isSingleArea.value
                        ? "data-location-name"
                        : "data-area-name",
                getTarget: (idx) => areas.value[idx].name,
            },
            location: {
                attr: "data-location-name",
                getTarget: (idx) => selectedAreaLocations.value[idx].name,
            },
            theme: {
                attr: "data-theme-name",
                getTarget: (idx, currentLocation) =>
                    getTextWithoutSign(currentLocation.themes[idx].name),
            },
        };

        // 尋找元素的通用函數
        const findElement = (type, params) => {
            if (type === "area") {
                const attr = selectors.area.attr();
                return findElementByAttribute(`[${attr}]`, attr, params.target);
            } else if (type === "location") {
                return findElementByAttribute(
                    `[data-location-name]`,
                    "data-location-name",
                    params.target
                );
            } else if (type === "theme") {
                // 主題需要特殊處理
                const locationElement = findElementByAttribute(
                    "[data-location-name]",
                    "data-location-name",
                    params.currentLocation.name
                );
                if (!locationElement) return null;

                return Array.from(
                    locationElement.querySelectorAll("[data-theme-name]")
                ).find(
                    (element) =>
                        getTextWithoutSign(
                            element.getAttribute("data-theme-name")
                        ) === params.target
                );
            }
            return null;
        };

        // 統一的索引設置函數
        const setIndexWithScroll = (
            indexRef,
            newIndex,
            isClick,
            findElementParams
        ) => {
            indexRef.value = newIndex;

            if (isClick && findElementParams) {
                const targetElement = findElement(
                    findElementParams.type,
                    findElementParams.params
                );
                scrollToElement(targetElement);
            }
        };

        // 設置區域索引
        const setIndex = (idx, isClick = false) => {
            setIndexWithScroll(selectedIndex, idx, isClick, {
                type: "area",
                params: {
                    target: selectors.area.getTarget(idx),
                },
            });
        };

        // 設置位置索引
        const setSelectedLocationIndex = (idx, isClick = false) => {
            setIndexWithScroll(selectedLocationIndex, idx, isClick, {
                type: "location",
                params: {
                    target: selectors.location.getTarget(idx),
                },
            });
        };

        // 優化：設置主題索引
        const setSelectedThemeIndex = (idx, isClick = false) => {
            const currentLocation = selectedAreaLocations.value?.[selectedLocationIndex.value];

            if (!currentLocation) return;

            setIndexWithScroll(selectedThemeIndex, idx, isClick, {
                type: "theme",
                params: {
                    target: selectors.theme.getTarget(idx, currentLocation),
                    currentLocation,
                },
            });
        };

        // 優化：滾動處理函數
        const handleScroll = debounce(() => {
            const viewportHeight = window.innerHeight;
            const scrollPosition = window.scrollY;
            const midViewport = scrollPosition + viewportHeight / 2;

            // 檢查元素是否在視口中間
            const isElementActive = (element) => {
                const rect = element.getBoundingClientRect();
                const elementTop = rect.top + scrollPosition;
                const elementBottom = elementTop + rect.height;
                return (
                    elementTop <= midViewport && elementBottom >= midViewport
                );
            };

            // 更新區域索引
            const updateAreaIndex = () => {
                const areaElements =
                    document.querySelectorAll("[data-area-name]");
                let activeElement = areaElements[0];

                for (const element of areaElements) {
                    if (isElementActive(element)) {
                        const areaName = element.getAttribute("data-area-name");
                        const matchingIndex = areas.value.findIndex(
                            (area) => getTextWithoutSign(area.name) === areaName
                        );

                        if (matchingIndex !== -1) {
                            setIndex(matchingIndex, false);
                            activeElement = element;
                            break;
                        }
                    }
                }

                return activeElement;
            };

            // 更新位置索引
            const updateLocationIndex = (activeArea) => {
                if (!activeArea) return null;

                const locationElements = activeArea.querySelectorAll(
                    "[data-location-name]"
                );
                let activeLocation = null;

                for (const element of locationElements) {
                    if (isElementActive(element)) {
                        const locationName =
                            element.getAttribute("data-location-name");
                        const areasToSearch = isSingleArea.value
                            ? areas.value
                            : selectedAreaLocations.value;

                        const matchingLocationIndex = areasToSearch?.findIndex(
                            (area) =>
                                getTextWithoutSign(area.name) === locationName
                        );

                        if (matchingLocationIndex !== -1) {
                            if (isSingleArea.value) {
                                setIndex(matchingLocationIndex, false);
                            } else {
                                setSelectedLocationIndex(
                                    matchingLocationIndex,
                                    false
                                );
                            }
                            activeLocation = element;
                            break;
                        }
                    }
                }

                return activeLocation;
            };

            // 更新主題索引
            const updateThemeIndex = (activeLocation) => {
                if (!activeLocation) return;

                const themeElements =
                    activeLocation.querySelectorAll("[data-theme-name]");

                for (const element of themeElements) {
                    if (isElementActive(element)) {
                        const themeName =
                            element.getAttribute("data-theme-name");
                        const currentLocation =
                            selectedAreaLocations.value?.[
                                selectedLocationIndex.value
                            ];

                        if (currentLocation) {
                            const matchingThemeIndex =
                                currentLocation.themes?.findIndex(
                                    (theme) =>
                                        getTextWithoutSign(theme.name) ===
                                        themeName
                                );

                            if (matchingThemeIndex !== -1) {
                                setSelectedThemeIndex(
                                    matchingThemeIndex,
                                    false
                                );
                                break;
                            }
                        }
                    }
                }
            };

            // 依序處理不同層級的元素
            const activeArea = updateAreaIndex();
            const activeLocation = updateLocationIndex(activeArea);
            updateThemeIndex(activeLocation);
        }, 100);

        const handleOverlayClick = (e) => {
            // 如果點擊的是 modal 外部，就關閉
            if (modalContentRef.value && !modalContentRef.value.contains(e.target)) {
                mobileFilterPopup.value = false;
            }
        };

        watch(
            () => mobileFilterPopup.value,
            async (newVal) => {
                if (newVal) {
                    syncTempStateFromFilters();
                    isVisible.value = true;
                    await nextTick();
                    setTimeout(() => {
                        isActive.value = true;
                        BindCompareButton(compareGroups.value);
                    }, 2);
                } else {
                    isActive.value = false;
                    setTimeout(() => {
                        isVisible.value = false;
                    }, 400);
                }
            },
            { immediate: true }
        );

        onMounted(() => {
            // 使用 passive: true 優化滾動效能
            window.addEventListener("scroll", handleScroll, { passive: true });
        });

        onUnmounted(() => {
            // 清理事件監聽器
            window.removeEventListener("scroll", handleScroll);
        });


        return {
            isVisible,
            isActive,
            mobileFilterPopup,
            priceRangeMin,
            priceRangeMax,
            dateRangeStart,
            dateRangeEnd,
            updatePriceRange,
            updateDateRange,
            updateCheckbox,
            availableWeekdays,
            availableDayRanges,
            tags,
            airlines,

            tempQuick,
            tempSort,
            tempGroupType,
            tempWeekDay,
            tempFeatureTags,
            tempAirline,
            tempPriceRange,
            tempDateRange,
            selectedAreaLocations,
            reset,
            submit,
            priceRangeKey,
            modalContentRef,
            handleOverlayClick
        };
    },
    template: html`
        <div
            class="filter_dialog Com_PopupBg"
            :style="{ display: isVisible ? 'block' : 'none' }"
            :class="{ active: isActive }"
            @click="handleOverlayClick"
        >
            <div class="modal-content Com_halfPopup" ref="modalContentRef">
                <div class="modal_header">
                    <button
                        class="close_btn"
                        @click="mobileFilterPopup = false"
                    >
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.8 28L0 25.2L11.2 14L0 2.8L2.8 0L14 11.2L25.2 0L28 2.8L16.8 14L28 25.2L25.2 28L14 16.8L2.8 28Z"
                                fill="#8A8A8A"
                            />
                        </svg>
                    </button>
                </div>
                <div class="modal_body scrollbarWidth">
                    <div class="filter_content">
                        <div class="m_anchor" v-if="!isSearch">
                            <div class="filter_title">快速前往</div>
                            <div class="m_anchor_wrap">
                                <ul
                                    class="anchor_list"
                                    v-if="quickData.length == 1"
                                >
                                    <li
                                        class="anchor_btn"
                                        :class="{ active: tempQuick === idx }"
                                        v-for="(quick, idx) in quickData[0].items"
                                        @click="tempQuick=idx"
                                    >
                                        {{getSubName(quick.showField ||
                                        quick.subClassificationName)}}
                                    </li>
                                </ul>
                                <ul
                                    class="anchor_list"
                                    v-if="quickData.length > 1"
                                >
                                    <li
                                        class="anchor_btn"
                                        :class="{ active: tempQuick === idx }"
                                        v-for="(quick, idx) in quickData"
                                        @click="tempQuick=idx"
                                    >
                                        {{quick.classificationName}}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="filterbox view">
                            <div class="filter_title">顯示切換</div>
                            <div class="filterSpace_view">
                                <div class="view_btn_box">
                                    <button
                                        class="view_btn view_btn-list tab"
                                        :class="{ active: tempGroupType === 'horizontal' }"
                                        data-layout="horizontal"
                                        @click="tempGroupType='horizontal'"
                                    >
                                        <img
                                            src="/Content/Img/Shop/icon_list-black.png"
                                            alt=""
                                        />
                                        產品
                                    </button>
                                    <button
                                        class="view_btn view_btn-img tab vertical"
                                        :class="{ active: tempGroupType === 'vertical' }"
                                        data-layout="vertical"
                                        @click="tempGroupType='vertical'"
                                    >
                                        <img
                                            src="/Content/Img/Shop/icon_img-black.png"
                                            alt=""
                                        />
                                        圖卡
                                    </button>
                                    <button
                                        class="view_btn view_btn-date tab"
                                        :class="{ active: tempGroupType === 'uni' }"
                                        data-layout="uni"
                                        @click="tempGroupType='uni'"
                                    >
                                        <img
                                            src="/Content/Img/Shop/icon_calendar-black.png"
                                            alt=""
                                        />
                                        日期
                                    </button>
                                </div>
                            </div>
                            <div class="filterbox sort">
                                <div class="filter_title">排序</div>
                                <div class="filterSpace_radio">
                                    <div class="">
                                        <label for="s_1">
                                            日期（從近到遠）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_1"
                                                value="date_asc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>
                                    <div class="">
                                        <label for="s_2">
                                            日期（從遠到進）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_2"
                                                value="date_desc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>
                                    <div class="">
                                        <label for="s_3">
                                            價格（從低到高）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_3"
                                                value="price_asc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>
                                    <div class="">
                                        <label for="s_4">
                                            價格（從高到低）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_4"
                                                value="price_desc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>

                                    <div class="">
                                        <label for="s_5">
                                            天數（從少到多）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_5"
                                                value="day_asc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>
                                    <div class="">
                                        <label for="s_6">
                                            天數（從多到少）
                                            <input
                                                type="radio"
                                                name="sort_1"
                                                id="s_6"
                                                value="day_desc"
                                                v-model="tempSort"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <BudgetFilter
                            :key="'test'+(priceRangeMin + priceRangeMax)||'loading' "
                            :minValue="priceRangeMin"
                            :maxValue="priceRangeMax"
                            :priceRange="tempPriceRange"
                            @update:range="updatePriceRange"
                        />
                        <DatepickerFilter
                            :dateRangeStart="dateRangeStart"
                            :dateRangeEnd="dateRangeEnd"
                            :dateRange="tempDateRange"
                            @update:updateDateRange="updateDateRange"
                        />

                        <div class="filterbox state">
                            <div class="filter_title">出團狀態</div>
                            <div class="filterSpace_checkbox">
                                <div class="filter_checkbox">
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        id="s-1"
                                    />
                                    <label class="checkbox_label" for="s-1">
                                        <div class="checkbox_textBox">
                                            <span>保證出發</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="filter_checkbox">
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        id="s-2"
                                    />
                                    <label class="checkbox_label" for="s-2">
                                        <div class="checkbox_textBox">
                                            <span>即將成團</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="filterbox">
                            <div class="filter_title">出發星期</div>
                            <div class="filterSpace_checkbox">
                                <div
                                    class="filter_checkbox"
                                    v-for="day in availableWeekdays"
                                    :key="day"
                                >
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        :id="'Www-' + day"
                                        :checked="tempWeekDay.has(dayIndex(day))"
                                        @change="updateCheckbox('selectedWeekdays', dayIndex(day), $event.target.checked)"
                                    />
                                    <label
                                        class="checkbox_label"
                                        :for="'Www-' + day"
                                    >
                                        <div class="checkbox_textBox">
                                            <span>{{ day }}</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="filterbox">
                            <div class="filter_title">旅遊天數</div>
                            <div class="filterSpace_checkbox">
                                <div
                                    class="filter_checkbox"
                                    v-for="(range, index) in availableDayRanges"
                                    :key="range.originalIndex"
                                >
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        :id="'Wdd-' + range.originalIndex"
                                        :checked="range.active"
                                        @change="updateCheckbox('dayRanges', range.originalIndex, $event.target.checked)"
                                    />
                                    <label
                                        class="checkbox_label"
                                        :for="'Wd-' + range.originalIndex"
                                    >
                                        <div class="checkbox_textBox">
                                            <span>
                                                {{
                                                    range.rangeStart === 0
                                                        ? range.rangeEnd + '天以下'
                                                        : range.rangeEnd === 0
                                                            ? range.rangeStart + '天以上'
                                                            : range.rangeStart + '~' + range.rangeEnd + '天'
                                                }}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="filterbox">
                            <div class="filter_title">特色標籤</div>
                            <div class="filterSpace_tags">
                                <div
                                    class="filter_tag"
                                    v-for="tag in tags"
                                    :key="tag"
                                >
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        :id="'Wee-' + tag"
                                        :checked="tempFeatureTags.has(tag)"
                                        @change="updateCheckbox('featureTags', tag, $event.target.checked)"
                                    />
                                    <label class="tag_label" :for="'Wee-' + tag">
                                        <div class="tag_text">
                                            <span>{{ tag }}</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="filterbox">
                            <div class="filter_title">航空公司</div>
                            <div class="filterSpace_checkbox flight">
                                <div
                                    class="filter_checkbox"
                                    v-for="airline in airlines"
                                    :key="airline"
                                >
                                    <input
                                        class="checkbox_input"
                                        type="checkbox"
                                        :id="'Wff-' + airline"
                                        :checked="tempAirline.has(airline)"
                                        @change="updateCheckbox('selectedAirlines', airline, $event.target.checked)"
                                    />
                                    <label
                                        class="checkbox_label"
                                        :for="'Wff-' + airline"
                                    >
                                        <div class="checkbox_textBox">
                                            <span>
                                                {{ airlineName(airline) }}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal_footer">
                    <div class="btn_group">
                        <button class="clean_btn" @click="reset">清除全部</button>
                        <button class="filter_btn" @click="submit">送出</button>
                    </div>
                </div>
            </div>
        </div>
    `,
    methods: {
        dayIndex(day) {
            const days = [
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
            ];
            return days.indexOf(day);
        },
        airlineName(code) {
            return transService.airlineMap[code];
        },
        getSubName: function (showField) {
            //移除括號內的內容
            const result = showField.replace(/（.*?）/g, "");
            return result;
        },
        setGroupShowType(groupShowType) {
            this.groupShowType = groupShowType;
        },
    },
});
